import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

export type EquipmentStatus = { [key: string]: string; };

@Injectable({
  providedIn: 'root'
})
export class EquipmentStatusService {

  constructor(private http: HttpClient) { }

  public getEquipmentStatuses(ratingType: string | null): Observable<EquipmentStatus[]>{
        let params = new HttpParams();
        if (ratingType) {
            params = params.set('rating_type', ratingType);
        }
        return this.http.get<EquipmentStatus[]>('api/v1/espp/equipment_status', { params })
            .pipe(
                catchError( errorResponse => {
                    return throwError([])
                })
            )
  }
}
